export const ACTIF = 'Actif';
export const TRANSMIS = 'Transmis';
export const AUCUN = 'Aucun';

export const LISTE_ETAT = [
  { libelle: 'listeJournalEcriture.lot.etat.aucun', code: AUCUN },
  { libelle: 'listeJournalEcriture.lot.etat.actif', code: ACTIF },
  { libelle: 'listeJournalEcriture.lot.etat.transmis', code: TRANSMIS },
];

export const ACTION_TRANSFERE = 'transferer';
export const ACTION_TRANSFERE_TASSER = 'transferer_tasser';
